/* eslint-disable jsx-a11y/anchor-is-valid */
// bibliotecas externas
import { useState, useEffect, useContext } from "react";
import { Row } from "reactstrap";
// context
import { MatchContext } from "../providers/match";

const PaginationV2 = ({
  currentIndex,
  setCurrentIndex,
  countData,
  maxItemPerPage,
  maxPageButtonsToShow,
}) => {
  const allPages = [];
  const distanceCheckNext = Math.floor(maxPageButtonsToShow / 2);
  const distanceCheckPrevious = Math.ceil(maxPageButtonsToShow / 2);

  for (let page = 1; page <= Math.ceil(countData / maxItemPerPage); page += 1) {
    allPages.push(page);
  }

  const lastPage = allPages.length;

  const [firstButtonIndex, setFirstButtonIndex] = useState(0);
  const [lastButtonIndex, setLastButtonIndex] = useState(maxPageButtonsToShow);
  // context
  const { matchConfig } = useContext(MatchContext);

  useEffect(() => {
    if (currentIndex > lastPage) {
      setCurrentIndex(lastPage);
      goToFirstPage();
    }
  }, [lastPage, currentIndex, setCurrentIndex]);

  // recebe a página atual e retrocede uma página, deslocando a janela de botões quando a primeira página visível é ultrapassada
  const handlePreviousPage = (currentPage) => {
    const firstButton = 0;
    const firstPage = 1;

    if (currentPage === firstPage) return;

    // caso não passe da primeira pagina
    if (
      currentPage - distanceCheckPrevious === firstButtonIndex &&
      firstButtonIndex !== firstButton
    ) {
      setLastButtonIndex(lastButtonIndex - 1);
      setFirstButtonIndex(firstButtonIndex - 1);
    }

    setCurrentIndex(currentPage - 1);
  };

  // recebe a página atual e avança uma página, deslocando a janela de botões quando a última página visível é ultrapassada
  const handleNextPage = (currentPage) => {
    if (currentPage === lastPage) return;

    // caso não passe da ultima pagina
    if (
      currentPage + distanceCheckNext === lastButtonIndex &&
      lastButtonIndex !== lastPage
    ) {
      setLastButtonIndex(lastButtonIndex + 1);
      setFirstButtonIndex(firstButtonIndex + 1);
    }

    setCurrentIndex(currentPage + 1);
  };

  // reseta a janela de botões e navega para a primeira página
  const goToFirstPage = () => {
    const firstPage = 0;
    setLastButtonIndex(maxPageButtonsToShow);
    setFirstButtonIndex(firstPage);
    setCurrentIndex(1);
  };

  // desloca a janela de botões para o final e navega para a última página
  const goToLastPage = () => {
    setLastButtonIndex(lastPage);
    setFirstButtonIndex(lastPage - maxPageButtonsToShow);
    setCurrentIndex(lastPage);
  };

  const isFirstPage = currentIndex === 1 || countData === 0;
  const isLastPage = allPages.length === currentIndex || countData === 0;

  return (
    <Row className="row-pagination-v2">
      <nav
        aria-label="Navegação de página"
        className="nav-pagination-v2"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            width: "100%",
          }}
        >
          <button
            type="button"
            className="btn btn-light pagination-v2-btn"
            disabled={isFirstPage}
            onClick={goToFirstPage}
            aria-label="Primeira página"
            style={{ padding: "10px 12px" }}
          >
            <i className="fas fa-angles-left"></i>
          </button>

          <button
            type="button"
            className="btn btn-primary pagination-v2-btn pagination-v2-btn-main"
            disabled={isFirstPage}
            onClick={() => handlePreviousPage(currentIndex)}
            aria-label="Página anterior"
            style={{ padding: "10px 16px", backgroundColor: matchConfig?.colorButton ?? "#485EC4", }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>

          <div
            className="pagination-v2-indicator"
            style={{
              minWidth: "84px",
              textAlign: "center",
              fontWeight: 600,
              fontSize: "14px",
              backgroundColor: matchConfig?.colorButton ?? "#485EC4",
              padding: "10px 16px",
              color: "white",
            }}
          >
            {countData === 0 ? "0 / 0" : `${currentIndex} / ${lastPage}`}
          </div>

          <button
            type="button"
            className="btn btn-primary pagination-v2-btn pagination-v2-btn-main"
            disabled={isLastPage}
            onClick={() => handleNextPage(currentIndex)}
            aria-label="Próxima página"
            style={{ padding: "10px 16px", backgroundColor: matchConfig?.colorButton ?? "#485EC4", }}
          >
            <i className="fas fa-arrow-right"></i>
          </button>

          <button
            type="button"
            className="btn btn-light pagination-v2-btn"
            disabled={isLastPage}
            onClick={goToLastPage}
            aria-label="Última página"
            style={{ padding: "10px 12px" }}
          >
            <i className="fas fa-angles-right"></i>
          </button>
        </div>
      </nav>
    </Row>
  );
};

export default PaginationV2;
